/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';
import { get, isEmpty, startCase, toLower } from 'lodash';

import BookingWrapMessage from './booking-wrap-message';
import LicensePlate from '../license-plate';
import CircleColor from '../circle-color';
import LicensePlateColor from '../license-plate-color';

const BookingScheduleSetCarDriverNotice = ({ content }) => {
  //   const dispatch = useDispatch();

  //   const requestId = content.id;
  //   useEffect(() => {
  //     if (toastId) {O
  //       dispatch(removePushAssignedToBookingRequest(requestId));
  //     }
  //   }, [toastId, requestId]);
  const beforeChange = get(content, 'beforeChange', {});
  const changeDriver = !!beforeChange?.driver;
  const changeCar = !!beforeChange?.car;

  const title =
    changeDriver && changeCar
      ? 'đã đổi xe và tài xế.'
      : changeDriver
      ? 'đã đổi tài xế.'
      : changeCar
      ? 'đã đổi xe.'
      : 'đã xác nhận xe và tài xế.';

  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'error.main' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
              <Typography sx={{ mr: 0.5 }} variant="subtitle1">
                {content.tagKey}
              </Typography>
              <Typography variant="subtitle1" color="secondary.main">
                {title}
              </Typography>
            </Stack>

            <BookingWrapMessage borderColor="warning.main">
              <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                <Typography variant="body2">Tài xế :</Typography>
                <Typography variant="subtitle2" color="primary.main">
                  {startCase(toLower(content.driver.name))}
                </Typography>
              </Stack>
              <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                <Typography variant="body2">Số điện thoại :</Typography>
                <Typography variant="subtitle2" color="primary.main">
                  {content.driver.phoneNumber}
                </Typography>
              </Stack>
              <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                <Typography variant="body2">Xe :</Typography>
                <Typography variant="subtitle2" color="primary.main">
                  {content.car?.model?.name}
                  {` (${content.car.inServiceYear})`}
                </Typography>
              </Stack>
              <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                <Typography variant="body2">Biển số :</Typography>
                <LicensePlateColor licensePlate={content.car.licensePlate} color={content.car.color} />
              </Stack>
            </BookingWrapMessage>
            {!isEmpty(beforeChange) && (
              <BookingWrapMessage borderColor="grey.A700">
                {beforeChange?.driver && (
                  <>
                    <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                      <Typography variant="body2">Tài xế :</Typography>
                      <Typography variant="subtitle2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                        {startCase(toLower(beforeChange.driver.name))}
                      </Typography>
                    </Stack>
                    <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                      <Typography variant="body2">Số điện thoại :</Typography>
                      <Typography variant="subtitle2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                        {beforeChange.driver.phoneNumber}
                      </Typography>
                    </Stack>
                  </>
                )}
                {beforeChange?.car && (
                  <>
                    <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                      <Typography variant="body2">Xe :</Typography>
                      <Typography variant="subtitle2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                        {beforeChange.car?.model?.name} {` (${beforeChange.car.inServiceYear})`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                      <Typography variant="body2">Biển số :</Typography>
                      <LicensePlateColor
                        licensePlate={beforeChange.car.licensePlate}
                        color={beforeChange.car.color}
                        licenceSx={{ textDecoration: 'line-through!important', color: 'text.secondary' }}
                      />

                      {/* <Typography variant="subtitle2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                        {beforeChange.car.licensePlate}
                      </Typography> */}
                    </Stack>
                  </>
                )}
              </BookingWrapMessage>
            )}
            <BookingWrapMessage>
              <Typography variant="body2">{content.bookingDescription}</Typography>{' '}
            </BookingWrapMessage>
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />
    </>
  );
};

export default BookingScheduleSetCarDriverNotice;
